import React from 'react'

import { formatCurrency, formatNumber } from '../../lib/format-number'
import { getDmp, getDmpProduct } from '../../lib/format-dmps'
import ReactTooltip from 'react-tooltip'

const DetailsRevenueRow = ({ property }) => (
    <tr className="revenue-list revenue-list--header">
        <td className="revenue-list revenue-list--property">
            <ReactTooltip id={'licensenameBtnTooltip_' + property.arListId + '_' + property.dmpProductId + '_' + property.market} type="dark" effect="solid">
                <span>{property.licenseName}</span>
            </ReactTooltip>

            <div
                data-tip
                data-for={'licensenameBtnTooltip_' + property.arListId + '_' + property.dmpProductId + '_' + property.market}
                style={{ 'text-overflow': 'ellipsis', overflow: 'hidden', 'white-space': 'nowrap', width: '500px' }}>
                <a target="_blank" href={'/licenses?filter=' + property.licenseId}>
                    {property.licenseName}
                </a>
            </div>
        </td>

        <td className="revenue-list revenue-list--property">{getDmp(property.market)}</td>
        <td className="revenue-list revenue-list--property ">{getDmpProduct(property.dmpProductId)}</td>
        <td className="revenue-list revenue-list--property">{property.licensee}</td>
        <td className="revenue-list revenue-list--revenue">{formatNumber(property.impressions)}</td>
        <td className="revenue-list revenue-list--revenue">{formatNumber(property.clicks)}</td>
        <td className="revenue-list revenue-list--revenue">{formatCurrency(property.revenueGross, property.currency)}</td>
        <td className="revenue-list revenue-list--revenue">{formatCurrency(property.revenueNet, property.currency)}</td>
    </tr>
)

export default DetailsRevenueRow
